import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Biometrics API
export const biometricsApi = {
  getCatalog: () => axios.get(`${API}/biometrics/metrics-catalog`),
  getMeasurements: (range = 30) => axios.get(`${API}/biometrics/measurements?range=${range}`),
  getMeasurement: (id) => axios.get(`${API}/biometrics/measurements/${id}`),
  createMeasurement: (data) => axios.post(`${API}/biometrics/measurements`, data),
  getSummary: (range = 30) => axios.get(`${API}/biometrics/summary?range=${range}`),
};

// Devices API
export const devicesApi = {
  getDevices: () => axios.get(`${API}/devices`),
  createDevice: (data) => axios.post(`${API}/devices`, data),
  deleteDevice: (id) => axios.delete(`${API}/devices/${id}`),
};

// Hub API
export const hubApi = {
  // Exercises
  getExercises: (params = {}) => axios.get(`${API}/hub/exercises`, { params }),
  createExercise: (data) => axios.post(`${API}/hub/exercises`, data),
  updateExercise: (id, data) => axios.patch(`${API}/hub/exercises/${id}`, data),
  
  // Workout Templates
  getWorkoutTemplates: (params = {}) => axios.get(`${API}/hub/workouts/templates`, { params }),
  getWorkoutTemplate: (id) => axios.get(`${API}/hub/workouts/templates/${id}`),
  getTemplateQuota: () => axios.get(`${API}/hub/workouts/templates/quota`),
  createWorkoutTemplate: (data) => axios.post(`${API}/hub/workouts/templates`, data),
  assignWorkout: (data) => axios.post(`${API}/hub/workouts/assign`, data),
  getAssignedWorkouts: () => axios.get(`${API}/hub/workouts/assigned`),
};

// Sessions API
export const sessionsApi = {
  getSessions: (range = 30) => axios.get(`${API}/sessions?range=${range}`),
  createSession: (data) => axios.post(`${API}/sessions`, data),
  addSetLog: (sessionId, data) => axios.post(`${API}/sessions/${sessionId}/set-logs`, data),
  completeSession: (sessionId, data) => axios.patch(`${API}/sessions/${sessionId}`, data),
  getSessionSummary: (id) => axios.get(`${API}/sessions/${id}/summary`),
  getQuota: () => axios.get(`${API}/sessions/quota`),
};

// Nutrition API
export const nutritionApi = {
  getTemplates: () => axios.get(`${API}/nutrition/templates`),
  createTemplate: (data) => axios.post(`${API}/nutrition/templates`, data),
  getAssigned: () => axios.get(`${API}/nutrition/assigned`),
  logAdherence: (data) => axios.post(`${API}/nutrition/adherence`, data),
};

// Billing API (router /billing — catálogo real PLAN_CATALOG + upgrade 24h)
export const billingApi = {
  getPlans: () => axios.get(`${API}/billing/plans`),
  getMySubscription: () => axios.get(`${API}/billing/my-subscription`),
  getMode: () => axios.get(`${API}/billing/mode`),
  checkout: (planId, successUrl) => axios.post(`${API}/billing/checkout`, {
    plan_id: planId,
    success_url: successUrl,
  }),
  // Sprint G: upgrade sin recrear cuenta + ventana de revert 24h
  startUpgrade: (targetPlanId) => axios.post(`${API}/billing/upgrade/start`, {
    target_plan_id: targetPlanId,
  }),
  revertUpgrade: () => axios.post(`${API}/billing/upgrade/revert`),
  getUpgradeStatus: () => axios.get(`${API}/billing/upgrade/status`),
  // Canje de códigos de descuento / patrocinio
  redeemCode: (code) => axios.post(`${API}/billing/redeem-code`, { code }),
};

// Coach API
export const coachApi = {
  getClients: () => axios.get(`${API}/coach/clients`),
  addClient: (email) => axios.post(`${API}/coach/clients`, { email }),
  getClientDetail: (id) => axios.get(`${API}/coach/clients/${id}`),
  getDashboard: () => axios.get(`${API}/coach/dashboard`),
  getCommissions: () => axios.get(`${API}/coach/commissions`),
  getClientsComparison: (range = 30) => axios.get(`${API}/coach/clients/comparison?range=${range}`),
  getClientReportPdf: (id, range = 30) => axios.get(
    `${API}/coach/clients/${id}/report.pdf?range=${range}`,
    { responseType: 'blob' },
  ),
};

// Admin API
export const adminApi = {
  getKpis: () => axios.get(`${API}/admin/dashboard`),
  getUsers: (skip = 0, limit = 50) => axios.get(`${API}/admin/users?skip=${skip}&limit=${limit}`),
  getInbox: () => axios.get(`${API}/admin/inbox`),
  getPendingPlans: () => axios.get(`${API}/plans/pending`),
  approveWorkoutPlan: (planId, data) => axios.post(`${API}/plans/workout/${planId}/approval`, data),
  approveNutritionPlan: (planId, data) => axios.post(`${API}/plans/nutrition/${planId}/approval`, data),
  // Matching de ejercicios contra el Hub
  rematchWorkoutPlan: (planId) => axios.post(`${API}/plans/workout/${planId}/rematch`),
  linkExerciseToLibrary: (planId, params) => axios.post(`${API}/plans/workout/${planId}/exercises/link`, null, { params }),
  // Video manual (YouTube/Vimeo/URL) para un ejercicio del plan sin GIF
  setExerciseVideo: (planId, data) => axios.post(`${API}/plans/workout/${planId}/exercises/video`, data),
  // Corrección parcial con IA: una comida o un ejercicio, no el plan completo
  fixMeal: (planId, data) => axios.post(`${API}/plans/nutrition/${planId}/fix-meal`, data),
  fixExercise: (planId, data) => axios.post(`${API}/plans/workout/${planId}/fix-exercise`, data),
  fixPlanWithAI: (planType, planId, instruction) => axios.post(`${API}/plans/${planType}/${planId}/fix-with-ai`, { instruction }),
  // Edición manual del plan antes de aprobarlo (re-audita al guardar)
  editPlan: (planType, planId, changes) => axios.post(`${API}/ai-control/plans/${planType}/${planId}/edit`, changes),
  getGenerationStatus: (userId) => axios.get(`${API}/plans/generation-status/${userId}`),
  runUserAction: (userId, action) => axios.post(`${API}/admin/users/${userId}/actions/${action}`),
  searchLibraryExercises: (q) => axios.get(`${API}/hub/exercises`, { params: { q } }),
};

export default {
  biometricsApi,
  devicesApi,
  hubApi,
  sessionsApi,
  nutritionApi,
  billingApi,
  coachApi,
  adminApi,
};
